export function escapeCSVField(value) {
    if (value === null || value === undefined) return "";
    return `"${String(value).replace(/"/g, '""')}"`;
}

export const jsonToCsvString = (jsonObj) => {
    const headers = [
        "cluster",
        "description",
        "title",
        "key_point_1",
        "key_point_2",
        "key_point_3",
        "key_point_4",
        "key_point_5"
    ];

    const rows = [headers.join(",")];

    Object.entries(jsonObj).forEach(([clusterKey, clusterData]) => {
        const description = clusterData.description || "";
        const title = clusterData.title || "";
        const keyPoints = Array.isArray(clusterData.key_points) ? clusterData.key_points : [];

        const rowFields = [
            clusterKey,
            description,
            title,
            keyPoints[0] || "",
            keyPoints[1] || "",
            keyPoints[2] || "",
            keyPoints[3] || "",
            keyPoints[4] || ""
        ];

        rows.push(rowFields.map(escapeCSVField).join(","));
    });

    return rows.join("\n");
}